import { EntityAddress, SaveEntityAddress } from './entityAddresses'
import { faker } from '@faker-js/faker/locale/ru'
import { UuidIdGenerator } from '../../../common'

const idGenerator = new UuidIdGenerator()

export function mockEntityAddress(opts?: Partial<EntityAddress>): EntityAddress {
  return {
    id: Math.floor(Math.random() * (101 - 1) + 1),
    entityId: idGenerator.generate(),
    fieldsToIndex: faker.lorem.words({ min: 1, max: Math.floor(Math.random() * (7 - 1) + 1) }).split(' '),
    indexedAt: undefined,
    updatedAt: faker.date.past(),
    ...opts,
  }
}

export function mockSaveEntityAddress(opts?: Partial<SaveEntityAddress>): SaveEntityAddress {
  return {
    entityId: idGenerator.generate(),
    fieldsToIndex: faker.lorem.words({ min: 1, max: Math.floor(Math.random() * (7 - 1) + 1) }).split(' '),
    indexedAt: undefined,
    updatedAt: faker.date.past(),
    ...opts,
  }
}
